document.addEventListener("DOMContentLoaded", function () {

    /**********************************************************************
     Availability Toggle PLP Script
    ***********************************************************************/

    function initAvailabilityToggle() {
    const wrapper = document.querySelector(".filter-availability-wrapper");
    if (!wrapper) return;

    const checkbox = wrapper.querySelector('input[type="checkbox"][value="1"]'); // In stock
    const label = checkbox?.closest("label.facets__label");
    if (!checkbox || !label) return;

    requestAnimationFrame(() => {
        if (checkbox.checked) {
        label.classList.add("active", "animating");
        } else {
        label.classList.remove("active");
        }
        setTimeout(() => label.classList.remove("animating"), 400);
    });

    checkbox.addEventListener("change", function () {
        label.classList.add("animating");
        label.classList.toggle("active", this.checked);
        setTimeout(() => label.classList.remove("animating"), 400);
    });
    }

    initAvailabilityToggle();
    document.addEventListener("facets:updated", initAvailabilityToggle);
    document.addEventListener("shopify:section:load", initAvailabilityToggle);


    /**********************************************************************
    Sticky Header scroll to the section Script
    ***********************************************************************/

    document.querySelectorAll('.utility-bar a[href^="#"]').forEach(anchor => {
        anchor.addEventListener('click', function(e) {
            e.preventDefault();
            const target = document.querySelector(this.getAttribute('href'));
            const headerHeight = document.querySelector('.section-header').offsetHeight;

            window.scrollTo({
            top: target.offsetTop - headerHeight,
            behavior: 'smooth'
            });
        });
    });

    /**********************************************************************
    Sticky Header scroll to the section Script
    ***********************************************************************/


});

// window.replaceCartPageInner = function() {
//   // Fetch the current page HTML
//   fetch(window.location.href, { method: 'GET' })
//     .then((response) => response.text())
//     .then((htmlText) => {
//       // Parse the fetched HTML
//       const parser = new DOMParser();
//       const doc = parser.parseFromString(htmlText, 'text/html');

//       // Get the new .cart-page-inner from the fetched page
//       const newCartInner = doc.querySelector('div.cart-page-inner');
//       if (!newCartInner) return;

//       // Get the current .cart-page-inner on the page
//       const currentCartInner = document.querySelector('div.cart-page-inner');
//       if (!currentCartInner) return;

//       // Replace the current element with the new one
//       currentCartInner.replaceWith(newCartInner);
//     })
//     .catch((error) => {
//       console.error('Error replacing cart-page-inner:', error);
//     });
// }